import { ArrayField } from 'react-hook-form';

import { FieldController, ValidationRules } from '@dreryk/react-common';

import { DosagePeriod, DosageStageUnion } from '~libs.shared.prescription';

import { ExtendedDosageFormBean, ExtendedDosageFormController } from '../ExtendedDosageForm.types';

export type StageFieldName = `stages[${number}].${string}`;

export const createStageFieldNameFactory = (index: number) => (key: string): StageFieldName =>
   `stages[${index}].${key}`;

export const registerStageField = <VALUE>(
   register: ExtendedDosageFormController['register'],
   name: StageFieldName,
   validationRules?: ValidationRules<ExtendedDosageFormBean>
): FieldController<VALUE> => {
   return (register as (
      name: string,
      validationRules?: ValidationRules<ExtendedDosageFormBean>
   ) => FieldController<VALUE>)(name, validationRules);
};

export const setStageFieldValue = <VALUE>(
   setValue: ExtendedDosageFormController['setValue'],
   name: StageFieldName,
   value: VALUE
): void => {
   (setValue as (
      name: string,
      value: VALUE,
      config?: { shouldValidate?: boolean; shouldDirty?: boolean }
   ) => void)(name, value, { shouldValidate: true, shouldDirty: true });
};

export const triggerStageField = (trigger: ExtendedDosageFormController['trigger'], name: StageFieldName): void => {
   (trigger as (name: string) => void)(name);
};

export const computeOrdinalNumbers = (fields: Partial<ArrayField<DosageStageUnion>>[]): number[] =>
   fields.reduce<number[]>((accumulator, field, index) => {
      const isBreak = field.class === 'DosageBreak';
      const previousOfSameKind = fields
         .slice(0, index)
         .filter((previousField) => (previousField.class === 'DosageBreak') === isBreak).length;

      return [...accumulator, previousOfSameKind + 1];
   }, []);

export const BREAK_DURATION_DEFAULT: DosagePeriod = { amount: 1, unit: 'WEEK' };

export const CYCLE_DURATION_DEFAULT: DosagePeriod = { amount: 2, unit: 'WEEK' };

export { getStageDurationDays } from '~libs.shared.prescription';
